import { getDecodedToken } from './getDecodeToken';
import config from '../config';

export default function getUserMigrationStatus(): boolean {
  if (config.features.isConsumerBbidEnabled) {
    const decodedToken: any = getDecodedToken();
    const isAuthSrcBB = decodedToken && decodedToken.auth_src === 'BB';
    return isAuthSrcBB;
  }
  return false;
}
